import COMMON_LABELS from "../../../../common/locale/en_US";

export const LABELS: Record<string, string> = {
    ...COMMON_LABELS,
};

export default LABELS;
